import React, { useEffect, useRef, useState } from "react";
import { BreadCrumb } from "primereact/breadcrumb";
import { Button } from "primereact/button";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import "react-html5-camera-photo/build/css/index.css";
import { useHistory } from "react-router-dom";
import { handlePutRequest } from "../../services/PutTemplate";
import { toast } from "react-toastify";
import useViewOnly from "../../hooks/useViewOnly";
import styles from "./scan.module.scss";

function Scan() {
    const viewOnly = useViewOnly();
    const [role, setRole] = useState("");
    const [userId, setUserId] = useState("");
    const [data, setData] = useState("Not Found");
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const [scanBuffer, setScanBuffer] = useState({ code: "", time: 0 });
    const [bufferActive, setBufferActive] = useState(false);
    const [lastScanned, setLastScanned] = useState("");

    const breadItems = [{ label: "Home", url: "/" }, { label: "Scan" }];
    const home = { icon: "pi pi-home", url: "/" };

    useEffect(() => {
        const storedRole = localStorage.getItem("role");
        const storedUserId = localStorage.getItem("userId");
        setUserId(storedUserId);
        setRole(storedRole);
    }, []);

    const handleScan = async (scannedData) => {
        const now = Date.now();
        if (scanBuffer.code === scannedData && now - scanBuffer.time < 2000) return;

        setScanBuffer({ code: scannedData, time: now });
        setBufferActive(true);
        setTimeout(() => setBufferActive(false), 2000);

        if (role !== "airportStaff") {
            history.push("/package/" + scannedData);
        } else if (viewOnly) {
            toast.warn("An active shift is required to perform this action. Please clock in.");
        } else {
            setLoading(true);
            const payload = {
                inventoryNumber: scannedData,
                status: "out for delivery",
            };
            const result = await handlePutRequest(payload, "/editPackage");
            if (result?.success) {
                toast.success("Package status updated successfully");
            }
            setLoading(false);
        }
        setLastScanned(scannedData);
    };

    const inputBufferRef = useRef("");

    useEffect(() => {
        const handleKeyPress = (e) => {
            // Detect Enter key which typically comes at the end of a barcode scan
            if (e.key === "Enter") {
                const scannedCode = inputBufferRef.current.trim();
                if (scannedCode.length > 0) {
                    handleScan(scannedCode);
                    inputBufferRef.current = "";
                }
            } else {
                inputBufferRef.current += e.key;
            }
        };

        window.addEventListener("keypress", handleKeyPress);
        return () => window.removeEventListener("keypress", handleKeyPress);
    }, []);

    return (
        <div className={styles.scanContainer}>
            <div className={styles.pageHeader}>
                <div>
                    <h2>Scan</h2>
                    <BreadCrumb model={breadItems} home={home} />
                </div>
            </div>

            <p className={styles.instructionText}>Place the barcode in front of the camera to scan or capture an image.</p>

            {loading && (
                <div className={styles.bufferOverlay}>
                    <div className={styles.spinner}></div>
                    <p>Processing...</p>
                </div>
            )}

            {!loading && (
                <div className={styles.scannerSection}>
                    {
                        <BarcodeScannerComponent
                            width={300}
                            height={300}
                            onUpdate={(err, result) => {
                                if (result) {
                                    setData(result.text);
                                    handleScan(result.text);
                                }
                            }}
                        />
                    }
                </div>
            )}
            <div className={styles.status}>
                <strong>Last Scanned:</strong> <span className={lastScanned ? styles.valid : styles.invalid}>{lastScanned || "Not Found"}</span>
                {bufferActive && (
                    <div className={styles.bufferBarWrapper}>
                        <div className={styles.bufferBar}></div>
                        <span className={styles.bufferText}>Scanning</span>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Scan;
